import {
	AntDesignOutlined,
	ApartmentOutlined,
	CloudOutlined,
	ContainerOutlined,
	CopyrightOutlined,
	EyeOutlined,
	FileTextOutlined,
	HomeOutlined,
	LockOutlined,
	MenuOutlined,
	NodeExpandOutlined,
	SafetyOutlined,
	SettingOutlined,
	SisternodeOutlined,
	SubnodeOutlined,
	TeamOutlined,
	UserOutlined,
} from "@ant-design/icons";

import { EmbeddedIcon, ExternalIcon, OutsidePageIcon, ProfileCardIcon } from "./local-icons";
import { RiAccountCircleLine, RiReactjsLine, RiUserSettingsLine } from "./ri";

/**
 * Icons used in the menu.
 */
export const menuIcons: Record<string, any> = {
	EmbeddedIcon,
	HomeOutlined,
	SafetyOutlined,
	CloudOutlined,
	FileTextOutlined,
	LockOutlined,
	EyeOutlined,
	NodeExpandOutlined,
	SisternodeOutlined,
	SubnodeOutlined,
	OutsidePageIcon,
	AntDesignOutlined,
	ContainerOutlined,
	ExternalIcon,
	RiReactjsLine,
	SettingOutlined,
	UserOutlined,
	TeamOutlined,
	MenuOutlined,
	ApartmentOutlined,
	RiAccountCircleLine,
	ProfileCardIcon,
	RiUserSettingsLine,
	CopyrightOutlined,
};
